<template>
  <v-layout wrap>

    <v-flex xs12 md12 v-if="embedded">
      <v-autocomplete
        box dense persistent-hint
        :items="items"
        :label="fieldLabel"
        :hint="hintText"
        :disabled="readonly"
        v-model="selection"
        no-data-text="No results"
        clear-icon="cancel"
        append-icon="keyboard_arrow_down">
      </v-autocomplete>
    </v-flex>
    <v-flex xs12 md6 v-else>
      <v-autocomplete
        box dense persistent-hint clearable
        :items="items"
        :label="fieldLabel"
        :hint="hintText"
        :disabled="readonly"
        v-model="selection"
        no-data-text="No results"
        append-icon="keyboard_arrow_down">
      </v-autocomplete>
    </v-flex>

        <!-- Autocomplete with menu 

          <v-flex xs12 md6>
      <v-autocomplete
        box dense
        :items="itemsDropdown"
        label="Dropdown with action menu"
        no-data-text="No results"
        append-icon="keyboard_arrow_down"
        class="with-vert-menu"
        >
        <template v-slot:append-outer>
               <v-menu>
                    <v-btn
                      flat
                      slot="activator"
                      icon
                      class="ma-0 pa-0"
                      dark
                      color="secondary"
                    >
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list dense>
                        <v-list-tile @click="">
                        <v-icon class="mr-2" color="secondary">cancel</v-icon>Clear
                      </v-list-tile>
                       <v-list-tile @click="">
                        <v-icon class="mr-2" color="secondary">attach_file</v-icon>Go to case
                      </v-list-tile>
                     </v-list>   
                  </v-menu>
            </template>
      </v-autocomplete>
    </v-flex>-->

  </v-layout>
</template>

<script>
import Helpers from "@/helpers.js"

export default {
  name: 'select-field',
  props: {
    field: {
      type: Object
    },
    data: {
      type: String
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    }
  },
  computed: {
    fieldLabel() {
      return (this.field.display_name) ? this.field.display_name : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    name() {
      if (this.field && this.field.name) {
        return this.field.name
      } else {
        return ""
      }
    },
    hintText() {
      if (this.field && this.field.guidance) { return this.field.guidance }
      return ""
    },
    items() {
      let opts = []
      if (this.field) {
        if (this.field.options) { opts = this.field.options }
      }
      return opts
    },
    selection: {
      get() {
        if (this.data) {
          return this.data
        } else {
          if (this.field.default_value) {
            return this.field.default_value
          } else {
            return ""
          }
        }
      },
      set(value) {
        this.$emit('update-item', { field: this.field.name, data: value, row: this.row })
        this.$emit("blurred", {
          field: this.field.name,
          data: value,
          row: this.row
        })
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) { readonly = this.field.readonly }
      return readonly
    }
  }
}
</script>

<style>
  .with-vert-menu.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot > input {
    padding-right:50px;
    position:relative;
  }

  .with-vert-menu.v-text-field.v-text-field--enclosed .v-input__append-outer {
    position: absolute;
    right: 38px;
    top: -4px;
  }

</style>